import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
//import { useNavigate } from "react-router-dom";

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined ? 'aws' : 'staging');
const Tdebug = (WhichEnv != 'aws');

// const loginURL = (WhichEnv == 'aws')?'https://dashboard.turbosteed.com':'https://192.168.1.210:3000';
const loginURL = process.env.REACT_APP_TURBO_LOGIN_URL;
// Create an  empty context at the global level.
const AuthCtx = createContext();


// StAuthGiver is used like a custom context provider here. It will provide access to
// the defined variables to child components in the app.
// Wrap the future children in Auth Provider. This will be used in the router.
// This will provide (or allow access to) AuthContect to the children in the future.
const StAuthGiver = ({ children }) => {

    // TODO: Need to program the authentication logic here.
    const [user, setUser] = useState(localStorage.getItem("turbosteedAcct") || "");
    const [token, setToken] = useState(localStorage.getItem("act_e") || "");
    //const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);

    Tdebug && console.log("StAuthGiver - start, user - " + user + ', token - ' + token);


    const getApiServer = () => {
        return `https://${process.env.REACT_APP_HOST_URL}`;
    }

    // TODO: Need to set and reset the local storage with the necessary data/tokens
    const loginAction = async (acct, authTok) => {

        Tdebug && console.log("StAuthGiver - loginAction, user - " + user + ', token - ' + token);
        Tdebug && console.log("StAuthGiver: new token is " + authTok);
        (acct != null) ? Tdebug && console.log("StAuthGiver: new user is " + acct) : Tdebug && console.log("StAuthGiver: No user provided");

        // Try logging in the user.

        // TODO: Handle the use case where the local storage user is not the same
        // as the user who logged in. And set the user accordingly.
        try {
            if (acct != null) {
                setUser(acct);
                localStorage.setItem('turbosteedAcct', acct);
            }

            setToken(authTok);
            localStorage.setItem('act_e', authTok);

            //localStorage.setItem('user', 'vivek');
            //navigate('/dashboard');


        } catch (err) {
            console.error(err.stack);
            console.error(err);
        }
    }

    const logOut = async () => {
        setIsLoading(true);
        Tdebug && console.log("Logging out");
        //navigate('/',  {replace: true});

        const acctSid = localStorage.getItem('turbosteedAcct');
        const act_e = localStorage.getItem('act_e');

        // Now logout from AWS.
        try {
            const response = await fetch(getApiServer() + '/users/' + acctSid + '/logout/', // + acctSid, 
                {
                    method: 'POST',

                    withCredentials: 'true',
                    credentials: 'include',   // Browser will send the cookies along with the request. (include => for CORS)
                    //body: authCode,
                    headers: {
                        //'Access-Control-Allow-Origin': 'http://localhost:3000', 
                        'Content-Type': 'application/json',
                        //'Authorization': 'Basic ' + btoa('f103ad881cafc3aec513ece0a7fe0628:df0fcf9b0dad1b2fab1d4e7a1e8700bdfeeef48a1d169c517f52635ae3e224af')
                        'Authorization': 'Basic ' + btoa(acctSid + ':' + act_e)

                    }
                }).then((response) => {
                    Tdebug && console.log(response);
                    Tdebug && console.log(response.headers);
                    Tdebug && console.log(response.data);
                    Tdebug && console.log(JSON.stringify(response));

                    if (response.ok == false) {
                        throw new Error(response.json());
                    }

                    return response.json();
                }).then((responseJson) => {
                    Tdebug && console.log(responseJson);

                }).catch((error) => {
                    Tdebug && console.log(error);
                    Tdebug && console.log("logOut: Will not take action!");
                });
        } catch (axe) {
            Tdebug && console.log("logOut" + axe);
        }finally{
            setIsLoading(false);
        }

        setUser('');
        setToken('');
        localStorage.removeItem('turbosteedAcct');
        localStorage.removeItem('act_e');
        localStorage.removeItem('sites');
        localStorage.removeItem('curSite');
        localStorage.removeItem('uDet');
        window.location.replace(loginURL);

    }



    // TODO: Need to throw errors and implement logout wherever required.

    return <AuthCtx.Provider value={{ token, user, loginAction, logOut, isLoading }}>{children}</AuthCtx.Provider>;

};

export default StAuthGiver;

// Export the useAuth function to access whatever is stored in AuthContect global.
export const useAuth = () => {
    return useContext(AuthCtx);
};

// Export the useAuth function to access whatever is stored in AuthContect global.
export const UseAuth = () => {
    return useContext(AuthCtx);
};